import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { testId } from 'ui-components/services/testid-service';

import style from './shared-classes.module.less';
import { emptyArray } from 'ui-components/default-props/empty';
import Global from '../../store/global-selectors';
import { notifyMarketplace as notifyMarketplaceAction } from '../../store/shipments/grid/shipments.grid.header.actions';

const NotifyMarketplaceButton = () => {
  const dispatch = useDispatch();
  const selectedFulfillmentIds = useSelector(Global.selectSelectedShipmentsSelectedShipmentIds) || emptyArray;
  const oneOrMoreShipmentSelected = selectedFulfillmentIds.length > 0;
  const disabled = !oneOrMoreShipmentSelected;
  const notifyMarketplace = useCallback(() => {
    dispatch(notifyMarketplaceAction(selectedFulfillmentIds));
  }, [selectedFulfillmentIds, dispatch]);

  return (
    <Button
      {...testId('notify-marketplace-button')}
      className={style['action-button']}
      disabled={disabled}
      onClick={notifyMarketplace}
      theme='tertiary'
    >
      <FormattedMessage defaultMessage='Notify Marketplace' description='gridHeader.notifyMarketplace' id='LkAgD/' />
    </Button>
  );
};

export default NotifyMarketplaceButton;
